/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef, useState } from "react";
import { useGLTF } from "@react-three/drei";
import { useThree, useFrame } from "@react-three/fiber";
import { useTrimesh, useBox } from "@react-three/cannon";

export function MazeModel(props) {
  const { nodes, materials } = useGLTF('/maze_joined.glb');
  const [ref, api] = useTrimesh(() => ({
    args: [
        nodes.Plane.geometry.attributes.position.array,
        nodes.Plane.geometry.index.array,
    ],
    type: "Static", // Set to Static if the walls do not move
    position: [0, 0, 0],
    rotation: [0, 0, 0],
    friction: 0,
    scale: [3, 1, 3],
    ...props,
  }), useRef());

  const { pointer } = useThree();

  // Add these at the top with your other state variables
  const [currentRotation, setCurrentRotation] = useState(0);

  const [currentRotationX, setCurrentRotationX] = useState(0);
  const [currentRotationZ, setCurrentRotationZ] = useState(0);

  useFrame((state, delta) => {
    if (ref.current) {
      // Get distance from center
      const distance = Math.sqrt(pointer.x * pointer.x + pointer.y * pointer.y);

      // Calculate angle based on mouse position
      const angleY = pointer.y; // For x-axis rotation (up/down)
      const angleX = pointer.x; // For z-axis rotation (left/right)

      // Scale rotation by distance from center for more intuitive control
      // With a much lower maximum speed
      const rotationFactor = Math.min(distance * 2.5, 5); // Lower maximum value
      const targetRotationX = -angleY * rotationFactor; // Up/down movement affects x-axis
      const targetRotationZ = -angleX * rotationFactor; // Left/right movement affects z-axis (negative for natural direction)

      // Interpolate between current and target rotation (smoother transition)
      // The lower the interpolation factor, the smoother but slower the rotation
      const interpolationFactor = Math.min(delta * 3, 0.1); // Adjust this value as needed

      // Track both x and z rotations separately
      const newRotationX =
        currentRotationX +
        (targetRotationX - currentRotationX) * interpolationFactor;
      const newRotationZ =
        currentRotationZ +
        (targetRotationZ - currentRotationZ) * interpolationFactor;

      // Update the rotation states
      setCurrentRotationX(newRotationX);
      setCurrentRotationZ(newRotationZ);

      // Apply rotation to the compound body
      ref.current.rotation.x = newRotationX;
      ref.current.rotation.z = newRotationZ;

      // Apply to physics api if you're using react-three/cannon
      api.rotation.set(0, newRotationX, 0);
    }
  });

  
  return (
    <group ref={ref} {...props} dispose={null}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Plane.geometry}
        // material={materials['Material.001']}
        scale={[1, 0.2, 1]}
      >
        <meshStandardMaterial
        color="black" // Set the color of the material
        roughness={0.6} // Adjust roughness (0 = smooth, 1 = rough)
        metalness={0.1} // Adjust metalness (0 = non-metal, 1 = metal)
      />
      </mesh>
    </group>
  )
}

useGLTF.preload('/maze_joined.glb')